<div class="account-section">
  <div class="my-section-box">
    @if (true) {
      <form [formGroup]="currentProductForm">
        <div class="my-section-box__headline">
        {{ 'common.value_calculator_product_performance_title' | cxTranslate }}</div>
        <div class="my-section-box currentProduct" id="currentProduct">
          <div class="my-section-box-inner fleet-info-block">
            <div class="row col-12">
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-8 px-0">
                <div class="col-12 px-0 row">
                  <div class="col-8 col-xs-8 col-sm-6 pr-0">
                    <div class="form-group">
                      <label class="control-label selectLabel" for="brandOfActuator">
                        {{ 'common.value_calculator_brandOfActuator' | cxTranslate }}*
                      </label>
                      <div class="control select">
                        <select class="form-control" formControlName="brandOfActuator">
                          @for (x of brandOfActuator; track x) {
                            <option [value]="x.code">{{ x.name}}</option>
                          }
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="airdisk-button-block">
              <button type="button" class="btn btn-primary endaSureBack visitorInfoNext yellow-btn"
                (click)="endaSureBack()"><img src="/icons/link-right-white.svg" class="right-arrow" alt="">
              {{ 'common.value_calculator_back_button' | cxTranslate }}</button>
              <button type="button" class="btn btn-primary endaSureNxt visitorInfoNext yellow-btn"
                (click)="endaSureNxt()">{{ 'common.value_calculator_next_button' | cxTranslate }}
                <img src="/icons/link-right-white.svg" class="right-arrow" alt=""></button>
              </div>
            </div>
          </div>
        </form>
      }
    </div>
  </div>